import {TelegramBotAuthorizationResponse} from '../../../../api/proto';
import i18n from '../../../../i18n';

const {t} = i18n;

export const getTelegramBotAuthError = (type?: TelegramBotAuthorizationResponse.Error | null): string => {
  switch (type) {
    case TelegramBotAuthorizationResponse.Error.INVALID_TOKEN:
      return t('api_telegram_bot_authorization_invalid_token');
  }

  if (type && TelegramBotAuthorizationResponse.Error[type]) {
    return TelegramBotAuthorizationResponse.Error[type]?.toLowerCase().replace(/_/g, ' ');
  }

  return t('api_telegram_bot_authorization_failed');
};

export default getTelegramBotAuthError;